export default __webpack_public_path__ + "static/media/noMovie.af693814.jpg";